export const DRAFTING_MODE_OPTIONS = [
  {
    id: 'petition',
    label: 'Petition',
    description: 'Jurisdiction, relief, material facts, and grounds.',
  },
  {
    id: 'reply',
    label: 'Reply',
    description: 'Measured answers to the other side with cleaner support.',
  },
  {
    id: 'written_submission',
    label: 'Written Submission',
    description: 'Short propositions, authorities, and bench-ready sequencing.',
  },
  {
    id: 'hearing_note',
    label: 'Hearing Note',
    description: 'Chronology, oral points, and likely bench questions.',
  },
  {
    id: 'case_summary',
    label: 'Case Summary',
    description: 'Posture, chronology, issues, and proof gaps.',
  },
  {
    id: 'notice',
    label: 'Notice',
    description: 'Facts, breach, demand, and reservation of rights.',
  },
  {
    id: 'issue_note',
    label: 'Issue Note',
    description: 'One issue, current support, and what still needs proof.',
  },
];

const MODE_HINTS = {
  petition: ['petition', 'writ', 'plaint', 'appeal', 'application'],
  reply: ['reply', 'rejoinder', 'counter', 'objection', 'response'],
  written_submission: ['written submission', 'written submissions', 'submission', 'argument note'],
  hearing_note: ['hearing note', 'hearing notes', 'oral note', 'oral arguments', 'hearing prep'],
  case_summary: ['case summary', 'brief', 'summary', 'overview'],
  notice: ['notice', 'legal notice', 'demand notice'],
  issue_note: ['issue note', 'issue brief', 'issue memo'],
};

export function inferDraftingMode(doc = {}) {
  const explicit = String(doc.drafting_mode || '').trim().toLowerCase().replace(/-/g, '_');
  if (DRAFTING_MODE_OPTIONS.some((option) => option.id === explicit)) return explicit;

  const combined = [
    doc.type,
    doc.title,
    doc.template_snapshot?.title,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  const found = DRAFTING_MODE_OPTIONS.find((option) =>
    (MODE_HINTS[option.id] || []).some((hint) => combined.includes(hint))
  );
  return found?.id || 'written_submission';
}

export function getDraftingModeMeta(mode) {
  return DRAFTING_MODE_OPTIONS.find((option) => option.id === mode) || DRAFTING_MODE_OPTIONS[2];
}
